import { api } from './client'

/** Uma caixa de WhatsApp — de qual conta da Meta são os modelos. */
export type CaixaDeWhatsapp = { id: number; nome: string; telefone: string | null }

/**
 * Um modelo como a Meta o descreve.
 *
 * `situacao` vem no vocabulário da Meta (`APPROVED`, `PENDING`, `REJECTED`,
 * `PAUSED`, `DISABLED`); quem traduz é a tela.
 */
export type ModeloDoWhatsapp = {
  id: string
  nome: string
  idioma: string
  categoria: string
  situacao: string
  motivoDaRecusa: string | null
  cabecalho: string | null
  corpo: string | null
  rodape: string | null
  botoes: string[]
}

export type NovoModelo = {
  nome: string
  categoria: 'UTILITY' | 'MARKETING'
  idioma: string
  corpo: string
  exemplos: string[]
  cabecalho?: string
  rodape?: string
  botoes?: string[]
}

/**
 * Os modelos de mensagem do WhatsApp (demanda 231).
 *
 * 🔴 O token da Meta nunca passa por aqui: o back o lê do Chatwoot, caixa a
 * caixa, e fala com a Meta sozinho.
 */
export const modelosDoWhatsapp = {
  caixas: () => api.get<CaixaDeWhatsapp[]>('/whatsapp/caixas'),

  listar: (caixa: number) => api.get<ModeloDoWhatsapp[]>(`/whatsapp/caixas/${caixa}/modelos`),

  criar: (caixa: number, novo: NovoModelo) =>
    api.post<{ id: string | null; situacao: string | null; sincronizado: boolean }>(
      `/whatsapp/caixas/${caixa}/modelos`,
      novo,
    ),

  /**
   * ⚠️ Com o `id`: sem ele a Meta apaga o nome **em todos os idiomas** — o
   * `pt_BR` iria junto com o `en_US` que se quis apagar.
   */
  apagar: (caixa: number, nome: string, id?: string) =>
    api.delete<void>(
      `/whatsapp/caixas/${caixa}/modelos/${encodeURIComponent(nome)}${id ? `?id=${encodeURIComponent(id)}` : ''}`,
    ),

  sincronizar: (caixa: number) => api.post<void>(`/whatsapp/caixas/${caixa}/modelos/sincronizar`, {}),
}
